<template>
  <md-card>
    <md-card-content>
      <h3 class="h3">
        Metadata
      </h3>

      <language-key-form
        :values="metadata.title"
        title="title"
        @update="onTitleChange"
      />

      <language-key-form
        :values="metadata.description"
        title="description"
        @update="onDescriptionChange"
      />

      <div class="icon-field-container">
        <img
          :src="metadata.icon"
          alt=""
        >
        <md-field>
          <label>Image URL</label>
          <md-input v-model="metadata.icon" />
        </md-field>
      </div>

      <md-switch v-model="metadata.is_permanent_disabled">
        Permanently disabled
      </md-switch>
    </md-card-content>
  </md-card>
</template>
<script>
import LanguageKeyForm from "@/components/Forms/LanguageKeyForm";

export default {
    name: "NodeMetadataForm",
    components: {
        LanguageKeyForm
    },
    props: {
        metadata: {
            type: Object,
            default: () => ({
                title: {},
                description: {},
                icon: ""
            })
        }
    },
    methods: {
        onTitleChange(newValue) {
            this.metadata.title = newValue;
        },
        onDescriptionChange(newValue) {
            this.metadata.description = newValue;
        }
    }
};
</script>
<style scoped lang="scss">
    .icon-field-container {
        display: flex;
        img {
            width: 30px !important;
            height: 30px !important;
            margin: auto 10px auto 0;
        }
    }
</style>
